function getCookieUrl() {
  if (process.env.NODE_ENV === 'development') {
    return '.joinlede.local';
  } else if (document.location.hostname === 'analytics.allegrocdp.com') {
    return '.allegrocdp.com';
  }
  return '.ledebeacon.com';
}

export default getCookieUrl();